// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070918/js/" + chunkId + "." + {"44":"64d973a1","225":"4b5771dc","481":"740a7177","486":"3f519902","770":"d6a03404"}[chunkId] + ".0.8793354902170548.chunk.js";
};